const IconSort = (props) => (
    <svg width="28" height="19" viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 4.70825L28 4.70825" stroke="black" strokeWidth="2"/>
        <path d="M0 14.7083L28 14.7083" stroke="black" strokeWidth="2"/>
        <circle cx="9" cy="4.70825" r="3" fill="white" stroke="black" strokeWidth="2"/>
        <circle cx="19" cy="14.7083" r="3" fill="white" stroke="black" strokeWidth="2"/>
    </svg>
  );
  
  export default IconSort;